import { ReservationTagSlot } from './get'


export type UpdateReservationTagReq = { name: string }
export type UpdateReservationTagRes = ReservationTagSlot

export const UPDATE_RESERVATION_TAG = '/v2/pms/reservation-tags/:tag_id/'
